import React, { useCallback, useRef, useState, useEffect, Ref } from 'react'
import { Button, Spin, Card } from 'antd'
import { SBack, SLowcodeList, SGeneralForms, SListTabs } from 'shj-components'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import ReceivableList from '../receivableList'
import InvoiceRegistration from '../invoiceRegistration'
import RefundConfirmation from '../refundConfirmation'
import PaymentDetails from '../paymentDetails'
import VerificationDetails from '../verificationDetails'
// import TransferDetails from '../transferList'
import { findOrderAccountDtlResponseByRequest } from '@/services/fmsServices'
import { findAuditPassResponseListByPage } from '@/services/fmsConfig'
import KeepAlive, { useAliveController } from 'react-activation'
import { DownOutlined, UpOutlined, DoubleRightOutlined, } from '@ant-design/icons'
import WhiteList from '../whiteList'

export default function Details() {
  const { pathname } = useLocation()
  const history = useNavigate()
  const { dropScope } = useAliveController()
  const listRef = useRef<any>()
  const collectionInfoRef = useRef<any>()
  const { id, orderId, dealMode } = useParams()
  const [isVisible, setIsVisible] = useState(true)
  const [loading, setLoading] = useState(false)
  const [detailsInfo, setDetailsInfo] = useState<any>(null)
  useEffect(() => {
    initFn()
  }, [id])
  const [hasWhiteListData, setHasWhiteListData] = useState(false)

  const initFn = async () => {
    setLoading(true)
    findOrderAccountDtlResponseByRequest({ orderAccountId: id })
      .then(res => {
        setDetailsInfo(res)
        // 检查白名单数据
        return findAuditPassResponseListByPage(1,10,{orderId: orderId})
      })
      .then(whiteListRes => {
        setHasWhiteListData(whiteListRes?.total > 0)
        setLoading(false)
      })
      .catch(err => {
        setLoading(false)
      })
  }
  // 收款详情
  const collectionInfoConfig = [
    {
      title: '收款详情',
      customBtn: [
        <div  onClick={() => setIsVisible(!isVisible)}>
          {
            isVisible? <div style={{cursor: 'pointer',fontWeight: 400}}>
            <span>展开 </span><DoubleRightOutlined style={{transform: 'rotate(90deg)'}} />
          </div> : <div style={{cursor: 'pointer',fontWeight: 400}}>
            <span>收起 </span><DoubleRightOutlined style={{transform: 'rotate(270deg)'}} />
          </div>
          }
        </div>,
      ],
      formItem: [
        {
          name: 'orderNo',
          label: '订单号',
          spanCol: 6,
        },
        {
          name: 'orderAmount',
          label: '订单金额',
          spanCol: 6,
        },
        {
          name: 'payStatusName',
          label: '支付状态',
          spanCol: 6,
        },
        {
          name: 'orderStatusName',
          label: '订单状态',
          spanCol: 6,
        },
        {
          name: 'customerName',
          label: '客户姓名',
          spanCol: 6,
        },
        {
          name: 'customerPhone',
          label: '电话',
          spanCol: 6,
        },
        {
          name: 'serviceAddressName',
          label: '服务地址',
          spanCol: 6,
        },
        // {
        //   name: 'shjThirdOrderNoInfo',
        //   label: '三方订单',
        //   spanCol: 6,
        // },
        {
          name: 'contractNo',
          label: '主合同号',
          spanCol: 6,
        },
        {
          name: 'customerId',
          label: '客户ID',
          spanCol: 6,
        },
        {
          name: 'companyOrgName',
          label: '门店',
          spanCol: 6,
        },
        {
          name: 'companyConfigName',
          label: '财务主体',
          spanCol: 6,
        },
        {
          name: 'receiptAmount',
          label: '收款金额合计',
          spanCol: 6,
        },
        {
          name: 'receivableAmount',
          label: '应收金额合计',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'unReceiveAmount',
          label: '应收余额合计',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'receiptRefundAmount',
          label: '退款金额合计',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'receiptUnverifiedAmount',
          label: '收款未核销金额合计',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'bizTagName',
          label: '需求标签',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'budgetArea',
          label: '报价面积',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'contractAmount',
          label: '主合同金额',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'beforeStartContractAmount',
          label: '开工前补充合同总金额',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'afterStartContractAmount',
          label: '开工后补充合同总金额',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'signDate',
          label: '签单日期',
          isHideItem: isVisible,
          type: 'dateTime',
          spanCol: 6,
        },
        {
          name: 'actualStartDate',
          label: '实际开工日期',
          isHideItem: isVisible,
          type: 'dateTime',
          spanCol: 6,
        },
        {
          name: 'actualEndDate',
          label: '实际竣工日期',
          isHideItem: isVisible,
          type: 'dateTime',
          spanCol: 6,
        },
        {
          name: 'projectManagerName',
          label: '项目负责人',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'designerDeptName',
          label: '设计部门',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'designerName',
          label: '设计师',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'salesManDeptName',
          label: '营销部门',
          isHideItem: isVisible,
          spanCol: 6,
        },
        {
          name: 'salesManName',
          label: '营销员',
          isHideItem: isVisible,
          spanCol: 6,
        },
      ],
    },
  ]
  //大tab 画像 跟进 订单
  const items = [
    {
      key: '1',
      label: '应收明细',
      auth: 'ReceivableListAuth',
      children: (
        <ReceivableList style={{ fontSize: 16 }} id={id} orderId={orderId} dealMode={dealMode} financialOrgCode={detailsInfo?.financialOrgCode}  />
      ),
    },
    {
      key: '2',
      label: '收款明细',
      auth: 'PaymentDetailsAuth',
      children: <PaymentDetails id={id} orderId={orderId} orderNo={detailsInfo?.orderNo} customerId={detailsInfo?.customerId} financialOrgCode={detailsInfo?.financialOrgCode}  />,
    },
    {
      key: '3',
      label: '核销明细',
      auth: 'VerificationDetailsAuth',
      children: <VerificationDetails id={id} />,
    },
    {
      key: '4',
      label: '退款确认',
      auth: 'RefundConfirmationAuth',
      children: <RefundConfirmation id={id} orderId={orderId} dealMode={dealMode} />,
    },
    {
      key: '5',
      label: '发票登记',
      auth: 'InvoiceRegistrationAuth',
      children: <InvoiceRegistration id={id} />,
    },
    // {
    //   key: '6',
    //   label: '转款查询',
    //   children: <TransferDetails id={id} orderId={orderId} />,
    // },
    hasWhiteListData && {
      key: '6',
      label: '收款白名单',
      children: <WhiteList id={id} orderId={orderId} />,
    },
  ].filter(Boolean) // 过滤掉false的值
  return (
    <KeepAlive name={pathname} id={'keep' + location.pathname}>
      {/* <SBack
        title={`订单收款详情`}
        // level={2}
        // goPath={() => {
        //   dropScope(pathname) // 清除缓存
        //   history(-1) // 返回上一页
        // }}
      ></SBack> */}
        <div style={{ backgroundColor: '#fff', padding: '20px 15px 15px 15px', minWidth: '800px' }}>
          <Spin spinning={loading}>
            <div style={{ marginTop: -10 }}>
              <SGeneralForms
                isDetail={true}
                configs={collectionInfoConfig}
                detailsData={detailsInfo || undefined}
                ref={collectionInfoRef}
              />
            </div>
          </Spin>
          <SListTabs size="large" defaultActiveKey={'2'} destroyInactiveTabPane={true} items={items} hideExtra={false} />
        </div>
      {/* </SBack> */}
    </KeepAlive>
  )
}
